/**
 * Types for the Web Serial flashing state machine
 */

/** States of the flashing process */
export enum FlashState {
  IDLE = 'IDLE',
  CONNECTING = 'CONNECTING',
  DETECTING = 'DETECTING',
  ERASING = 'ERASING',
  WRITING = 'WRITING',
  VERIFYING = 'VERIFYING',
  DONE = 'DONE',
  ERROR = 'ERROR',
}

/** Human-readable labels for each state (Spanish) */
export const FLASH_STATE_LABELS: Record<FlashState, string> = {
  [FlashState.IDLE]: 'Listo',
  [FlashState.CONNECTING]: 'Conectando al puerto serie...',
  [FlashState.DETECTING]: 'Detectando chip...',
  [FlashState.ERASING]: 'Borrando memoria flash...',
  [FlashState.WRITING]: 'Escribiendo firmware...',
  [FlashState.VERIFYING]: 'Verificando escritura...',
  [FlashState.DONE]: '¡Programación completada!',
  [FlashState.ERROR]: 'Error durante la programación',
};

/** Bootstrap color class for each state */
export const FLASH_STATE_COLORS: Record<FlashState, string> = {
  [FlashState.IDLE]: 'secondary',
  [FlashState.CONNECTING]: 'info',
  [FlashState.DETECTING]: 'info',
  [FlashState.ERASING]: 'warning',
  [FlashState.WRITING]: 'primary',
  [FlashState.VERIFYING]: 'info',
  [FlashState.DONE]: 'success',
  [FlashState.ERROR]: 'danger',
};

/** Progress event emitted during flashing */
export interface FlashProgress {
  state: FlashState;
  /** Overall progress 0–100 */
  progress: number;
  /** User-facing message */
  message: string;
  /** Chip info after detection */
  chipInfo?: string;
  /** Error details when state is ERROR */
  error?: string;
}

/** Options for the flash operation */
export interface FlashOptions {
  /** Baud rate for communication (default: 115200) */
  baudRate?: number;
  /** Flash offset address (default: 0x00000 for ESP8266 single-app) */
  flashOffset?: number;
}

/** Callback type for progress updates */
export type FlashProgressCallback = (progress: FlashProgress) => void;
